<div class="input-wrapper">
  <app-upload-shapefile
    #shapefileUpload
    [displayConfig]="{
      showTitle: true,
      showDescription: false,
      customTitle: 'Efetuar o upload de um arquivo Shapefile compactado (.zip)',
      titlePosition: 'above',
      titleBold: false,
      customDescriptionUpload:
        'Clique aqui ou arraste arquivo shapefile (.shp, .zip) para fazer upload',
    }"
    (fileUploaded)="onFileUploaded($event)"
    [acceptFile]="shapefileTypes"
  ></app-upload-shapefile>

  <!-- Status de validação -->
  @if (shapefileName && isValidating) {
    <div class="validation-status validating">
      <mat-icon>hourglass_empty</mat-icon>
      <span>Validando arquivo...</span>
    </div>
  }

  @if (shapefileName && hasValidated && isValidFile) {
    <div class="validation-status success">
      <mat-icon>check_circle</mat-icon>
      <span>Arquivo validado com sucesso!</span>
    </div>
  }

  @if (shapefileName && hasValidated && !isValidFile) {
    <div class="validation-status error">
      <mat-icon>error</mat-icon>
      <span>Arquivo não passou nas validações:</span>
      <ul>
        @for (error of validationErrors; track error) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }
</div>
<hr />

<div class="button-group">
  <button mat-stroked-button color="primary" (click)="onCancel()">
    <mat-icon>arrow_back</mat-icon>Cancelar
  </button>
  <button
    mat-flat-button
    [disabled]="!canSubmit || (isLoading() | async) || isAnyLoading"
    color="primary"
    (click)="onSubmit()"
  >
    Concluir

    @if ((isLoading() | async) || isAnyLoading) {
      <mat-icon>
        <mat-spinner matIcon diameter="18"></mat-spinner>
      </mat-icon>
    } @else {
      <mat-icon>save</mat-icon>
    }
  </button>
</div>
